<template>
  <div ref="header">
    <van-overlay
      :show="isOpen"
      :lock-scroll="true"
      @click="
        isOpen = !isOpen
        showMenu = !showMenu
        secondMenu = false
      "
    />
    <div class="mobHeader" id="mob_header">
      <div class="menu clear">
        <div class="left">
          <img src="~@/assets/lib/images/logo.png" alt />
        </div>
        <div class="right">
          <van-icon
            :class="openOrClose"
            name="wap-nav"
            @click="
              isOpen = !isOpen
              showMenu = !showMenu
              secondMenu = false
            "
          />
        </div>
      </div>
      <!-- 下滑进入 -->
      <transition name="van-slide-down">
        <div class="menuBox" v-show="showMenu">
          <van-cell is-link @click="routerPush('/home')">
            <template #title>
              <span class="custom-title">
                <i class="iconfont icon01 f26 vertical_b mar5_r gray_7"></i>
                首页
              </span>
            </template>
          </van-cell>
          <van-cell is-link @click="secondMenu = !secondMenu">
            <template #title>
              <span class="custom-title">
                <i class="iconfont icon00 f26 vertical_b mar5_r gray_7"></i>
                解决方案
              </span>
            </template>
          </van-cell>
          <van-cell is-link @click="routerPush('/news')">
            <template #title>
              <span class="custom-title">
                <i class="iconfont icon03 f26 vertical_b mar5_r gray_7"></i>
                动态
              </span>
            </template>
          </van-cell>
          <van-cell is-link @click="routerPush('/partner')">
            <template #title>
              <span class="custom-title">
                <i class="iconfont icon02 f26 vertical_b mar5_r gray_7"></i>
                合作伙伴
              </span>
            </template>
          </van-cell>
          <!-- <van-cell is-link @click="routerPush('/news')">
            <template #title>
              <span class="custom-title">
                <i class="iconfont icon03 f26 vertical_b mar5_r gray_7"></i>合作案例
              </span>
            </template>
          </van-cell>-->
        </div>
      </transition>

      <!-- 又滑进入 -->
      <transition name="van-slide-down">
        <div class="secondMenuBox" v-show="secondMenu">
          <div class="back" @click="secondMenu = !secondMenu">
            <van-icon name="arrow-left mar5_r gray_7" />
            <i>解决方案</i>
          </div>
          <div class="cont">
            <van-cell
              is-link
              title="乡村振兴数字化解决方案"
              url="/solution/0"
            />
            <van-cell
              is-link
              title="农业单品行业大数据解决方案"
              url="/solution/1"
            />
            <van-cell
              is-link
              title="农业链主企业数字化解决方案"
              url="/solution/2"
            />
            <van-cell
              is-link
              title="现代农业产业园数字化解决方案"
              url="/solution/3"
            />
            <van-cell
              is-link
              title="农产品区域公用品牌数字化解决方案"
              url="/solution/4"
            />
            <van-cell
              is-link
              title="农产品批发市场/交易中心数字化解决方案"
              url="/solution/5"
            />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { isOpen: false, showMenu: false, secondMenu: false }
  },
  watch: {
    $route() {
      this.isOpen = false
      this.showMenu = false
      this.secondMenu = false
    },
  },
  computed: {
    openOrClose() {
      return this.isOpen ? 'opend' : 'closed'
    },
  },
  created() {},
  methods: {
    routerPush(path) {
      if (this.$route.path == path) return
      else {
        this.$router.push(path)
      }
    },
  },
}
</script>

<style lang="scss">
.mobHeader {
  height: 0.9rem;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 11;
  .menu {
    z-index: 10;

    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 0.9rem;
    padding: 0.25rem 0.3rem 0.2rem;
    background: #2b303b;
    .left {
      height: 100%;
      display: flex;
      align-items: center;
      img {
        width: 1.04rem;
        height: 0.38rem;
      }
    }
    .right {
      height: 100%;
      color: white;
      display: flex;
      align-items: center;
      font-size: 0.4rem;
      .opend {
        transform: rotate(90deg);
        transition: all 0.2s ease-in;
      }
      .closed {
        transform: rotate(0deg);
        transition: all 0.2s ease-in;
      }
    }
  }
  .menuBox {
    position: absolute;
    background: #fff;
    width: 100%;
    top: 0.9rem;
    z-index: 2;
    padding: 0.2rem 0;
  }
  .secondMenuBox {
    position: absolute;
    background: #fff;
    width: 100%;
    top: 0.9rem;
    z-index: 3;
    padding: 0.4rem 0 0.2rem 0.32rem;
    .back {
      font-size: 0.28rem;
      line-height: 0.42rem;
      i {
        vertical-align: middle;
      }
    }

    .cont {
      padding: 0.2rem 0 0 0.3rem;
      font-size: 0.16rem;
    }
  }
}
</style>
